import { useEffect, useState } from "react";
import { api } from "../../api";
import { APageHead, ATable, ABadge } from "../adminKit";

export default function AdminSubscriptions() {
  const [data, setData] = useState({ items: [] });
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/subscriptions").then(({ data }) => setData(data)).finally(() => setLoading(false)); }, []);
  return (
    <div className="space-y-4">
      <APageHead title="Subscription Management" subtitle="All subscriptions across plans. Billing runs through a Stripe-ready service abstraction (currently demo)." />
      <ATable loading={loading} rows={data.items} columns={[
        { key: "email", label: "User", render: (r) => <span className="text-white">{r.email}</span> },
        { key: "plan", label: "Plan", render: (r) => <ABadge tone={r.plan === "free" ? "default" : "green"}>{r.plan}</ABadge> },
        { key: "status", label: "Status", render: (r) => <ABadge tone={r.status === "active" ? "active" : "amber"}>{r.status}</ABadge> },
        { key: "billing_cycle", label: "Cycle" },
        { key: "cancel_at_period_end", label: "Cancels?", render: (r) => r.cancel_at_period_end ? <ABadge tone="red">At period end</ABadge> : "—" },
        { key: "current_period_end", label: "Renews", render: (r) => r.current_period_end ? new Date(r.current_period_end).toLocaleDateString() : "—" },
      ]} />
    </div>
  );
}
